const en = {
  translation: {
    lang: "en",
    clickToEnableSound: "Click to enable sound",
    reinvented: {
      title: "DIOR REINVENTED BY PHILIPPE STARCK",
      reinvented: [
        {
          letter: "R",
        },
        {
          letter: "E",
        },
        {
          letter: "I",
        },
        {
          letter: "N",
        },
        {
          letter: "V",
        },
        {
          letter: "E",
        },
        {
          letter: "N",
          attributes: {
            "data-rotation": "",
          },
          className: "yellow",
        },
        {
          letter: "T",
        },
        {
          letter: "E",
        },
        {
          letter: "D",
        },
      ],
      by: [
        {
          letter: "B",
        },
        {
          letter: "Y",
        },
      ],
      subtitle: "the Medallion armchair designed by Philippe Starck",
      intro: "The story of an icon reinvented",
      description: [
        "A symbol of the Louis XVI style so dear to Christian Dior, the Dior Medallion chair has been reinterpreted by Philippe Starck and transformed into an original armchair inspired by the emblematic figure of the founding-couturier.",
        "Named Monsieur Dior, this exceptional model, presented in a variety of materials and colors, combines the House’s distinctive references with a savoir-faire that stretches the limits of excellence.",
        "Continuing his quest for the minimal, Philippe Starck has created a work of art and object of desire that is revealed in an ensemble of furniture – the most comprehensive ever produced by the House – expanding the “Dior by Starck family,” and reflecting the freedom and inventiveness of the dialogue between Dior and the French designer.",
      ],
    },
    ellemurmura: {
      title:
        "The French creator has managed to reveal the very essence of the legend that the Medallion chair embodies in his eyes through several variations of this original model, notably emphasizing the delicacy of the iconic toile de Jouy.",
    },
    discover: "Discover Miss Dior Sweet",
    colorsAndFabrics: {
      title: "Colors and fabrics",
      description:
        "Available in a range of materials and colors (polished or lacquered aluminum, bouclé fabric and pink, black or fluorescent orange toile de Jouy), these exceptional pieces, made in Italy, reflect the virtuosity of the hand and the most demanding innovation.",
      closing_paragraph:
        "They are accompanied by “little brothers and sisters, such as various tables of different sizes, and stools, all of which are extremely elegant,” in the words of the famous French creator who dreamed up this exclusive series.",
    },
    collection: "An entire collection imagined by Philippe Starck",
    biography: {
      headline:
        "An internationally renowned French creator, Philippe Starck is considered one of the pioneers of democratic design",
      description:
        "Philippe Starck is acclaimed for his visionary, poetic works in numerous fields: design, architecture, interior design, and transportation. From his childhood spent beneath the drawing tables of his father, an aeronautical engineer, he learned a fundamental lesson: everything should be organized in an elegant and rigorous manner, both in human relationships and in the vision that precedes any creative gesture.",
      description_bis:
        "His deep understanding of the changes taking place in our time, his enthusiasm for imagining new ways of life, his love of ideas, and his concern for defending the intelligence of the practical – and the practicality of the intelligent – have enabled him to constantly push back the limits of contemporary know-how. With more than 10,000 creations to date, this tirelessly inventive citizen of the world continues his mission: to design places and objects that are aimed to be “good” before being beautiful.",
    },
    scenography: "Scenography",
    savoir_faire: {
      an: [
        {
          letter: "A",
          attributes: {
            "data-rotation": "",
          },
          className: "yellow",
        },
        {
          letter: "N",
        },
      ],
      unique: [
        {
          letter: "E",
        },
        {
          letter: "X",
        },
        {
          letter: "C",
        },
        {
          letter: "E",
        },
        {
          letter: "P",
        },
        {
          letter: "T",
        },
        {
          letter: "I",
        },
        {
          letter: "O",
        },
        {
          letter: "N",
        },
        {
          letter: "A",
        },
        {
          letter: "L",
        },
      ],
      savoir: [
        {
          letter: "S",
        },
        {
          letter: "A",
        },
        {
          letter: "V",
        },
        {
          letter: "O",
          attributes: {
            "data-rotation": "",
          },
          className: "salmon",
        },
        {
          letter: "I",
        },
        {
          letter: "R",
        },
      ],
      faire: [
        {
          letter: "-",
        },
        {
          letter: "F",
        },
        {
          letter: "A",
        },
        {
          letter: "I",
        },
        {
          letter: "R",
          attributes: {
            "data-rotation": "",
          },
          className: "yellow",
        },
        {
          letter: "E",
        },
      ],
      intro:
        "Made in Italy, this “couture furniture collection” transcends the boundaries of the possible, combining the poetry of handicraft with the most advanced technology.",
      bring:
        "To bring these exceptional pieces to life with ultimate finesse, Philippe Starck called on Italian artisans whose virtuosity is exemplified by an extraordinary mastery of metal during the decisive stage of cold flow.",
      specialist:
        "A specialist in injection molding, he developed a unique, elaborately engineered process, and selected aluminum of the utmost purity to ensure that each realization is of ultimate finesse.",
      molten:
        "Once molten, the liquid aluminum is poured into a concrete tank called a crucible, and then injected into a meticulously adjusted mold. A tremendous mastery of the material is then implemented to produce an infinitely precise form, adapted to the unusual architecture of this creation.",
      cleansed:
        "Then the pieces are cleansed of any imperfections in a final polishing stage before being dipped in an electrolytic bath for the black chrome and pink copper versions, or vacuum sprayed for the gold one.",
      longevity:
        "Longevity is a fundamental parameter in today’s creative endeavors. Thanks to its timeless design and the extreme durability of its materials, Miss Dior by Starck reveals an eternal cultural, historical, and symbolic aura.",
    },
  },
};

export default en;
